// extracted by mini-css-extract-plugin
module.exports = {"hotspots":"src-components-Page-components-stylesHotspots__hotspots--2OPPC","deactivate":"src-components-Page-components-stylesHotspots__deactivate--2xKkX"};